import { useQuery } from "react-query"
import { getAppointmentsById } from "api/Appointment";


export const useAppointmentById = (id: any) => {
    
    return useQuery<Array<any> | any>(
        ['dashboardAppointmentsss', id],
        () => getAppointmentsById({ app_id: id }),
        {
            enabled: !!id,
            onError(error: any) {
                console.error(error)
            }
        }
    )
}